export const getMerchantLayoutVars = () => {
  /**
   * TODO: When we support layouts, we define these values based on layout selected
   * Possible Layout values: 1, 2, 3
   */

  const merchantLayoutVars = {
    default: {
      templateAreas: `'column1' 'column2'`,
      templateColumns: "1fr",
    },
    over1024: {
      templateAreas: `'column1 column2'`,
      templateColumns: "1fr 400px",
    },
  };

  return merchantLayoutVars;
};
